// extracted by mini-css-extract-plugin
export default {"addServBox":"FormSpecialties_addServBox__u--hx","addBox":"FormSpecialties_addBox__4MYu2","consigner":"FormSpecialties_consigner__cKOKw","seller":"FormSpecialties_seller__hz3U5"};